import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import AcceptPurchaseDeposit from "./AcceptPurchaseDeposit";
import RejectPurchaseDeposit from "./RejectPurchaseDeposit";
import { trackPurchaseDepositDecisionPopupLoad } from "../../../services/analytics/OrderDetailsPageAnalytics";
import { UserContext } from "../../../context/userContext";
import DecisionIntro from "./DecisionIntro";
import { useVehicleData } from "../../../hooks/useVehicleData";

const PurchaseDepositDecision = ({ orderId }) => {
  const [decision, setDecision] = useState(null);
  const { t } = useTranslation();
  const { user } = useContext(UserContext);
  const { nameplate, modelYear } = useVehicleData(orderId);

  const handleBack = () => {
    setDecision(null);
  };

  const handleDecision = (selectedDecision) => {
    setDecision(selectedDecision);
  };

  const handleAnalyticsPageView = () => {
    trackPurchaseDepositDecisionPopupLoad(orderId, user, modelYear, nameplate);
  };

  if (decision === "accept") {
    return (
      <AcceptPurchaseDeposit
        orderId={orderId}
        backButton
        handleBack={handleBack}
      />
    );
  }

  if (decision === "cancel") {
    return (
      <RejectPurchaseDeposit
        orderId={orderId}
        backButton
        handleBack={handleBack}
      />
    );
  }

  return (
    <DecisionIntro
      handleDecision={handleDecision}
      text={t("common.actions.reviewPurchaseDepositExtended")}
      primaryActionText={t("common.buttonCtas.acceptPurchaseDeposit")}
      secondaryActionText={t("common.buttonCtas.rejectPurchaseDeposit")}
      analyticsPageView={handleAnalyticsPageView}
    />
  );
};

PurchaseDepositDecision.propTypes = {
  orderId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default PurchaseDepositDecision;
